import styled from "styled-components";
import { Paper } from "@material-ui/core/";

export const ListStyles = styled(Paper)`
display: flex;
margin: 10px;
padding: 10px;
height: 100%;
width: 16%;
&:hover {
    background: #f8f8f8;
}`;